import CommonFunction from "../shared/commonfunction";
import Config from "../lib/config";
import { Decryptdata, Encryptdata } from "./encode_decode";
import React from "react";

let commonfunc = null;

export const isEmpty = (value) =>
  value === undefined ||
  value === null ||
  (typeof value === "object" && Object.keys(value).length === 0) ||
  (typeof value === "string" && value.trim().length === 0);

export const normalizeUrl = (value) =>
  typeof value === "string" ? value.trim() : "";

export const isValidHttpsUrl = (value) => {
  const normalizedValue = normalizeUrl(value);
  if (isEmpty(normalizedValue)) {
    return false;
  }

  try {
    const parsedUrl = new URL(normalizedValue);
    return parsedUrl.protocol === "https:" && !isEmpty(parsedUrl.hostname);
  } catch (err) {
    return false;
  }
};

export const NumANdDotOnly = (data) => {
  var data = data.toString();
  var str = data
    ? data.includes(".")
      ? data.split(".").length >= 3
        ? (data.split(".")[0] + "." + data.split(".")[1]).toString()
        : data
      : data
    : data;
  return str.toString().replace(Config.NumDigitOnly, "");
};
export const NumberOnly = (data) => {
  return data.toString().replace(Config.NumberOnly, "");
};

const hasHeader = (headers, headerName) =>
  Object.keys(headers).some(
    (key) => key.toLowerCase() === headerName.toLowerCase()
  );

const deleteHeader = (headers, headerName) => {
  Object.keys(headers).forEach((key) => {
    if (key.toLowerCase() === headerName.toLowerCase()) {
      delete headers[key];
    }
  });
};

const appendSearchParam = (searchParams, key, value) => {
  if (value === undefined || value === null) {
    return;
  }

  if (Array.isArray(value)) {
    value.forEach((item) => appendSearchParam(searchParams, `${key}[]`, item));
    return;
  }

  if (typeof value === "object") {
    Object.entries(value).forEach(([nestedKey, nestedValue]) => {
      appendSearchParam(searchParams, `${key}[${nestedKey}]`, nestedValue);
    });
    return;
  }

  searchParams.append(key, value);
};

const buildUrlWithParams = (url, params) => {
  if (!params || typeof params !== "object") {
    return url;
  }

  let parsedUrl;
  let isRelativeUrl = false;

  try {
    parsedUrl = new URL(url);
  }
  catch (err) {
    isRelativeUrl = true;
    parsedUrl = new URL(
      url,
      typeof window !== "undefined" ? window.location.origin : "http://localhost"
    );
  }

  Object.entries(params).forEach(([key, value]) => {
    appendSearchParam(parsedUrl.searchParams, key, value);
  });

  return isRelativeUrl
    ? `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`
    : parsedUrl.toString();
};

const parseResponseData = async (response) => {
  const responseText = await response.text();

  if (!responseText) {
    return responseText;
  }

  try {
    return JSON.parse(responseText);
  }
  catch (err) {
    return responseText;
  }
};

const fetchAdapter = async (requestData) => {
  const headers =
    requestData?.headers && typeof requestData.headers === "object"
      ? { ...requestData.headers }
      : {};

  const requestOptions = {
    method: requestData?.method ? requestData.method.toUpperCase() : "GET",
    headers,
  };

  if (requestData?.data !== undefined) {
    if (requestData.data instanceof FormData) {
      deleteHeader(headers, "Content-Type");
      requestOptions.body = requestData.data;
    }
    else {
      if (!hasHeader(headers, "Content-Type")) {
        headers["Content-Type"] = "application/json";
      }
      requestOptions.body = JSON.stringify(requestData.data);
    }
  }

  const response = await fetch(
    buildUrlWithParams(requestData?.url, requestData?.params),
    requestOptions
  );

  if (!response.ok) {
    throw new Error(response.statusText || "Request failed");
  }

  return {
    data: await parseResponseData(response),
    status: response.status,
    statusText: response.statusText,
    headers: response.headers,
    ok: response.ok,
  };
};

export const axiosFunc = async (data) => {
  try{
    let Resp    =   {};
    // if(data?.url?.includes('/user/test')){
      // if(false){
        if(data?.params){
          data.params = { data: Encryptdata(data.params)  }
        }
        else if(data?.data){
          if(!(data?.data instanceof FormData)){
            data.data = { data: Encryptdata(data.data)  }
          }
        }
      // }
      
    // }
    data.headers = { Authorization : GetCookie() };
      Resp    =   await fetchAdapter(data)
      
      if(Resp?.data){
          Resp.data = isEmpty(Decryptdata(Resp.data)) ? Resp.data : Decryptdata(Resp.data)
      }
      if(Resp?.data?.status == false && !isEmpty(Resp?.data?.action) ){
        if(Resp?.data?.action?.navigate){
          commonfunc.Redirect(Resp?.data?.action?.redirectpage,(Resp?.data?.msg?Resp?.data?.msg:"Not Allowed"));
        }
        else if(Resp?.data?.action?.logout){
          commonfunc.LogOut(Resp?.data?.msg?Resp?.data?.msg:"Not Allowed");
        }
      }

      return Resp
  }
  catch (e) {
    console.log('axiosFunc error',e)
    return { data: {success: 'error', msg: "Axios Error", data: null } }
  }
}

export const FirstCaps = (data) => {
  try{
    return data[0].toLocaleUpperCase() + data.slice(1);
  }
  catch(err){
    console.log('FirstCaps_error',err)
    return data
  }
};

export const NumberChange = (data) => {
  try{
    return (isNaN(Number(data)) ? 0 : Number(data))
  }
  catch(err){
    console.log('NumberChange_error',err)
    return 0;
  }
}

export const MinuteHourFormat = (data) => {
  data = NumberChange(isEmpty(data) ? 0 : data);
  return (data < 10 ? "0" : "") + data;
};

export const GetCookie = () => {
  try{
    const usertoken = ("; " + document.cookie)
		.split(`; admintoken=`)
		.pop()
		.split(";")[0];
    return usertoken;
  }
  catch(err){
    console.log('GetCookie_error',err)
  }
}

export const ImgEmpty = (data) => {
  try {
    return (
      (typeof (data) == 'object' && !data?.type) ||
      data === undefined ||
      data == "undefined" ||
      data === null ||
      (typeof data === 'string' && data.trim().length === 0) ||
      (typeof data === 'string' && data === '0') ||
      (typeof data === 'number' && data === 0)
    )
  }
  catch(err){
    console.log('ImgEmpty_error',err)
    return false
  }
}

export const ImgUrl = (data) => {
  try{
    return URL.createObjectURL(data);
  }
  catch(err){
    console.log('ImgUrl_error',err)
    return ''
  }
}

export function UseHook () {
  commonfunc = CommonFunction()
  return(
    <></>
  )
}

export const ShortString = ( text, outputlength ) => {
  try{
    if(typeof(text)=='string'){
      outputlength = outputlength ? outputlength : text.length;
      if(text.length > outputlength){
        let crtlength = (outputlength - 3) / 2
        return (text.substring(0,crtlength)+"..."+text.substring(text.length-crtlength,text.length))
      }
      return text;
    }
    else{
      return text;
    }
  }
  catch(err){
    console.log('ShortString_error',err)
    return text
  }
}
